import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';



var url =  window.location.hostname;
var port = window.location.port;
const Heading = [['Basepack Code', 'Product Code ',  'Product Name', 'CBU Code', 'Ean',  'Invoicing Shelf Life', 'MRP',  'Offer',  'Pack Size',  'Price Lot',  'QR Code', 'SKU5 Code', 'SKU7 Code',  'SKU7 Desc',  'SKU7 Uom', 'Tester', 'Tester Ratio', 'UPC' ,'Volume' ,'Weight','Pack Size UOM','sku Uom', 'Status','Added On']]



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  
  constructor() {
   super();
   this.fetchBinData = this.fetchBinData.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);
   this.Successtoggle = this.Successtoggle.bind(this);
   this.ConfirmToggle = this.ConfirmToggle.bind(this);
   this.openConfirm = this.openConfirm.bind(this);

   /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
	  loading_overlay: false,	
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      fileNameVal: 'masterFile',
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,
      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,
      filtered_orderData : [],
      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
     
    };
  }




  componentDidMount(){
  this.fetchBinData();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = Util.getCookie('token');
      var location = Util.getCookie('selectedLocation');
      var username = Util.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }





  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));  
  }

  ConfirmToggle(){
    this.setState(prevState => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm(){
    this.setState({
      ConfirmModal: true
    })

  }



 


  fetchBinData(){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
		    loading_overlay:true
      })

      const payload = {
      
};

API.get("/product/combined_product_master/v1/view/", { param: payload })


      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         // if (err) throw err;

         this.setState({posts: data.data ,filtered_orderData : data.data})

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         console.log(this.state.tableRows);

      });
  }




  assemblePosts= () => {

    let posts =this.state.posts.map((post) => {

      return (

        {

          base_pack_code: post.base_pack_code,

          
          lb_sku_id: post.lb_sku_id,

          lb_sku_product_name: post.lb_sku_product_name,
          cbu_code: post.cbu_code,
          ean: post.ean,
          invoicing_shelf_life: post.invoicing_shelf_life,
          mrp: post.mrp,
          offer: post.offer,
          pack_size:<span> {post.pack_size} {post.pack_size_uom} </span>,
         
          price_lot: post.price_lot,
          qr_code: post.qr_code,
          sku5_code: post.sku5_code,
          sku7_code: post.sku7_code,
          sku7_description: post.sku7_description,
          sku7_uom: post.sku7_uom,
          tester: post.tester,
          tester_ratio: post.tester_ratio,
          upc: post.upc,
          volume: post.volume,
          weight: post.weight       

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts });
    } else {
      // var value = this.state.posts.filter(
      //   (val) =>
      //     val.lb_sku_id.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.base_pack_code.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.cbu_code.toString().includes(evt.toLowerCase()) ||
      //     val.lb_sku_product_name.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.ean.toString().includes(evt) ||
      //     val.offer.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.price_lot.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.qr_code.toLowerCase().includes(evt.toLowerCase()) || 
      //     val.sku5_code.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.mrp.toString().includes(evt) ||
      //     val.invoicing_shelf_life.toString().includes(evt.toLowerCase()) ||
      //     val.sku7_code.toLowerCase().includes(evt.toLowerCase()) || 
      //     val.sku7_uom.toLowerCase().includes(evt.toLowerCase())  ||
      //     val.tester.toString().includes(evt.toLowerCase()) || 
      //     val.tester_ratio.toString().includes(evt.toLowerCase())  ||
      //     val.volume.toString().includes(evt.toLowerCase())  ||
      //     val.upc.toString().includes(evt.toLowerCase())  ||
      //     val.sku7_description.toLowerCase().includes(evt.toLowerCase())  || 
      //     val.weight.toString().includes(evt.toLowerCase())


      // );
      var value = this.state.posts.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      

      this.setState({
        filtered_orderData: value,
      });
    }
  };




 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    const data = {

      columns: [
        {

          label:'Basepack Code',

          field:'base_pack_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'LB Product Code	',

          field:'lb_sku_id',
          sort: 'asc',
          width: 150

        },

        {

          label:'Product Name',

          field:'lb_sku_product_name',
          sort: 'asc',
          width: 150

        },

        {

          label:'CBU Code',

          field:'cbu_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'Ean',

          field:'ean',
          sort: 'asc',
          width: 150

        },

        {

          label:'Invoicing Shelf Life',

          field:'invoicing_shelf_life',
          sort: 'asc',
          width: 180

        },

        {

          label:'MRP',

          field:'mrp',
          sort: 'asc',
          width: 100

        },

        {

          label:'Offer',

          field:'offer',
          sort: 'asc',
          width: 120

        },

        {

          label:'Pack Size',

          field:'pack_size',
          sort: 'asc',
          width: 120

        },


        {

          label:'Price Lot',

          field:'price_lot',
          sort: 'asc',
          width: 120

        },

        {

          label:'QR Code',

          field:'qr_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'SKU5 Code',

          field:'sku5_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'SKU7 Code',

          field:'sku7_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'SKU7 Desc',

          field:'sku7_description',
          sort: 'asc',
          width: 150

        },

        {

          label:'SKU7 Uom',

          field:'sku7_uom',
          sort: 'asc',
          width: 150

        },
        {

          label:'Tester',

          field:'tester',
          sort: 'asc',
          width: 150

        },{

          label:'Tester Ratio',

          field:'tester_ratio',
          sort: 'asc',
          width: 100

        },
        {

          label:'UPC',

          field:'upc',
          sort: 'asc',
          width: 100

        },
        {

          label:'Volume',

          field:'volume',
          sort: 'asc',
          width: 100

        },
        {

          label:'Weight',

          field:'weight',
          sort: 'asc',
          width: 100

        },
        
         

        

      ],
      rows:this.state.tableRows,

    }



    return (
      <Col xl={12}>
	       {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          

         

          {
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">Combined Product Master</h4>
              
			  <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.filtered_orderData, "COMBINED PRODUCT MASTER", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
			<hr style={{marginTop:'30px',marginBottom:'0px'}}/>
             <MDBDataTable
                  scrollX
                  onSearch={this.filterData}
                  scrollY
                  sortable={false}
                  displayEntries={false}
                  striped
                  bordered
                  data={data}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'combined_product_master_view', 'datatable_pagination_change' )}
                />
          </CardBody>

          )}

        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={ConfirmModal}
          toggle={this.ConfirmToggle}
          style={{maxWidth: 456}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.ConfirmToggle} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4 style={{fontSize: 18}}> Are you sure you want to proceed?</h4>
            <br/>
            <h3 style={{fontSize: 17}}><strong> NOTE: </strong> Duplicate entries will be updated if you proceed. </h3>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff' , marginRight: 8}} className="modal_ok"  onClick={this.processData}>Ok</Button>
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.ConfirmToggle}>Cancel</Button>
          </ButtonToolbar>
        </Modal>





      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));